<div class="flex flex-col gap-y-5 justify-between h-full">
  @if (config.data?.showTitle) {
    <div class="text-2xl font-bold flex items-center justify-center bg-primary-light p-3 rounded-md">
      <h1
        [innerHTML]="resource.error.workflowOut.title"
        *ngIf="!isCustomContent() || !config.data?.title"
      ></h1>
      <h1
        *ngIf="isCustomContent()"
        [innerHTML]="config.data?.title"
        class="text-center"
      ></h1>
    </div>
  }

  <div class="flex flex-col justify-center gap-y-5">
    @if (config.data?.contentTemplate) {
      <ng-container *ngTemplateOutlet="config.data?.contentTemplate || null"></ng-container>
    } @else if (!isCustomContent()) {
      @if (config.data?.content && (config.data?.content)!.length > 0) {
        @for (line of config.data?.content!; track $index) {
          <p
            class="text-center"
            [innerHTML]="line"
          ></p>
        }
      } @else {
        <p
          class="text-center"
          [innerHTML]="resource.error.workflowOut.text1"
        ></p>
      }

      @if (loadPhone()) {
        <p-skeleton
          width="12rem"
          height="4rem"
          styleClass="mx-auto mb-2"
        />
      } @else {
        <p class="text-2xl font-bold text-center">{{ displayPhone() }}</p>
      }

      <p class="text-center">
        {{ resource.error.workflowOut.text2 }}
        <br />
        {{ resource.error.workflowOut.text3 }}
      </p>
    } @else {
      @for (line of config.data?.content!; track $index) {
        <p
          class="text-center"
          [innerHTML]="line"
        ></p>
      }
    }
  </div>

  <div
    class="flex items-center justify-center"
    [ngClass]="(config.data?.actions?.length ?? 0) > 1 ? 'gap-3' : ''"
  >
    @if (!isCustomContent()) {
      <button
        pButton
        type="button"
        class="button-NS w-fit-content font-bold mx-auto"
        [title]="resource.error.workflowOut.action"
        (click)="closePopup()"
      >
        {{ resource.error.workflowOut.action }}
      </button>
    } @else {
      @for (action of config.data?.actions!; track $index) {
        @if (action.type === 'cancel') {
          <button
            pButton
            type="button"
            class="button-outline font-bold mx-auto"
            [ngClass]="(config.data?.actions?.length ?? 0) > 1 ? 'w-full' : 'w-fit-content'"
            title="{{ action.text }}"
            (click)="closePopup()"
          >
            {{ action.text }}
          </button>
        } @else {
          <button
            pButton
            type="button"
            class="button-NS font-bold mx-auto"
            [ngClass]="(config.data?.actions?.length ?? 0) > 1 ? 'w-full' : 'w-fit-content'"
            title="{{ action.text }}"
            (click)="executeAction(action)"
          >
            {{ action.text }}
          </button>
        }
      }
    }
  </div>
</div>
